import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { GraphView } from 'src/app/model/generic-graph';
import { EPSDataItem, EPSGraphView, VerticalGraphType } from 'src/app/model/vertical-views';

/**
 * @description
 * This component acts as a container for vertical bar graph and its corresponding footer's deatils. 
 * It handles the connection between the two, according to the currently selected bar.
 */
@Component({
  selector: 'app-eps-slide',
  templateUrl: './eps-slide.component.html',
  styleUrls: ['./eps-slide.component.scss']
})
export class EpsSlideComponent {
  /**
   * data is an object of @see GraphView interface, containing a vertical bar graph and footer's details ( @see EPSDataItem )
   */
  @Input() data!: GraphView;
  public currentSelectedColumnIndex!: number;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.currentSelectedColumnIndex = (this.data.graph as EPSGraphView).data.data.findIndex(item => item.isDefault)
  }
  
  public onSelectGarphValue(columnIndex: number): void {
    this.currentSelectedColumnIndex = columnIndex;
    this.cdr.detectChanges();
  }

  get footerData(): EPSDataItem {
    return (this.data.graph as EPSGraphView).footer[this.currentSelectedColumnIndex];
  }

  public getBarType(data: GraphView): VerticalGraphType {
    if (data.title === 'LY' || data.title === 'BGT') {
      return VerticalGraphType.COMPARE_BAR;
    } else {
      return VerticalGraphType.SIMPLE_BAR;
    }
  }
}
